import React from 'react'
import {Switch} from "@headlessui/react";
import {MoneyLabel} from "../../../../../components/general/MoneyLabel.tsx";

type VATAmountWithToggleProps = {
    onChange: (checked: boolean | null) => void
    amount: number | null
    toggleState: boolean
    disabled?: boolean
    className?: string
}

export default function VATAmountWithToggle({
                                                onChange,
                                                amount,
                                                toggleState,
                                                disabled,
                                                className = '',
                                            }: VATAmountWithToggleProps) {
    return (
        <div className={`relative mt-1 ${className}`}>
            <div
                className="relative flex items-center justify-between rounded-full border-2 w-fit min-w-32 max-w-40 pt-2 pb-1 px-3">
                <div className="mb-1 text-gray-900">
                    {amount != null ? <MoneyLabel value={amount}/>
                        : '-'}
                </div>
                <div className="ml-5" onClick={(e) => e.stopPropagation()}>
                    <Switch
                        checked={toggleState}
                        onChange={onChange}
                        disabled={disabled}
                        className="group relative inline-flex h-4 w-7 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 data-[checked]:bg-primary"
                    >
                                    <span
                                        aria-hidden="true"
                                        className="pointer-events-none inline-block size-3 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-3"
                                    />
                    </Switch>
                </div>
            </div>
        </div>
    )
}
